import { render, staticRenderFns } from "./exam-question.vue?vue&type=template&id=c141203e"
import script from "./exam-question.vue?vue&type=script&lang=js"
export * from "./exam-question.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports